import script from "./fullscreenPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./fullscreenPopup.vue?vue&type=script&setup=true&lang=js"

import "./fullscreenPopup.vue?vue&type=style&index=0&id=6f67fe34&lang=css"

const __exports__ = script;

export default __exports__